import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { getClipInfo } from "./helpers";
import { Star, Sparkles, Loader2, Video, Replace } from "lucide-react";

export function WowShotsSection({ session, wowShots, generating, onAutoSelect, onOpenClipPicker }) {
  return (
    <section className="bg-white rounded-xl border border-[#E2E4E7] overflow-hidden" data-testid="production-wow-shots">
      <div className="px-5 py-4 border-b border-[#E2E4E7] flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-amber-50 flex items-center justify-center">
            <Star size={18} className="text-amber-600" />
          </div>
          <div>
            <h3 className="font-semibold text-[#020B23] text-sm" style={{ fontFamily: 'Sora, sans-serif' }}>WOW Shots</h3>
            <p className="text-xs text-[#94969C]">3 best clips to open the video with impact</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          {wowShots.length === 3 && <Badge className="text-xs bg-emerald-50 text-emerald-700 border-emerald-100">3 selected</Badge>}
          <Button size="sm" onClick={onAutoSelect} disabled={generating}
            data-testid="auto-select-wow-btn"
            className="text-xs bg-amber-500 hover:bg-amber-600 text-white h-7">
            {generating ? <><Loader2 size={11} className="mr-1 animate-spin" /> Selecting...</> :
             <><Sparkles size={11} className="mr-1" /> AI Auto-Select</>}
          </Button>
        </div>
      </div>
      <div className="p-5">
        <p className="text-sm text-[#676970] mb-3">
          {wowShots.length === 3
            ? "AI has selected the 3 most striking clips. Click any to swap it with a different clip."
            : "Click 'AI Auto-Select' to let the AI pick the 3 most visually striking clips, or select them manually."}
        </p>
        <div className="grid grid-cols-3 gap-3">
          {[0, 1, 2].map(i => {
            const ws = wowShots[i];
            const clipInfo = ws ? getClipInfo(session, ws.shot_id, ws.candidate_id) : null;
            return (
              <div key={i} className="relative group" data-testid={`wow-shot-${i}`}>
                <div className={`h-[120px] rounded-lg overflow-hidden border-2 ${clipInfo ? 'border-amber-300' : 'border-dashed border-[#D8D9DD]'} bg-black relative`}>
                  {clipInfo?.video_url ? (
                    <video src={clipInfo.video_url} className="w-full h-full object-contain" muted loop
                      onMouseEnter={e => e.target.play().catch(() => {})} onMouseLeave={e => { e.target.pause(); e.target.currentTime = 0; }} />
                  ) : clipInfo?.thumbnail_url ? (
                    <img src={clipInfo.thumbnail_url} alt={`WOW ${i + 1}`} className="w-full h-full object-contain" />
                  ) : (
                    <div className="w-full h-full flex flex-col items-center justify-center gap-1 bg-[#F3F3F9]">
                      <Video size={20} className="text-[#D8D9DD]" />
                      <span className="text-[10px] text-[#94969C]">Not selected</span>
                    </div>
                  )}
                  <span className="absolute top-1.5 left-1.5 text-[10px] bg-amber-500 text-white px-2 py-0.5 rounded-full font-bold">
                    WOW #{i + 1}
                  </span>
                  {clipInfo && (
                    <span className="absolute bottom-1.5 left-1.5 text-[10px] bg-black/60 text-white px-1.5 py-0.5 rounded">
                      {clipInfo.room_name}
                    </span>
                  )}
                </div>
                <button onClick={() => onOpenClipPicker(`wow-${i}`)}
                  data-testid={`wow-change-${i}`}
                  className="mt-1.5 w-full text-center text-[11px] py-1 rounded-md text-[#4D11F6] hover:bg-[#4D11F6]/5 font-medium transition-colors">
                  <Replace size={11} className="inline mr-1" />
                  {clipInfo ? 'Change clip' : 'Select clip'}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
